import React from 'react';
import ZsFormikDatePicker from "src/components/atoms/zsDatePicker";
import {validate} from "src/utils/yup";
import * as Yup from "yup";

export interface IElectricityMeterReadingDateProps {
}

export function ElectricityMeterReadingDate(props: IElectricityMeterReadingDateProps) {

    const getMinDate = () => {
        const d = new Date(new Date().toDateString());
        d.setDate(d.getDate() - 41);
        return d;
    }

    return (
        <>
            <label><span
                style={{color: '#F00'}}>*</span> Ablesedatum
                Strom</label>
            <ZsFormikDatePicker name="electricityMeterReadingDate"
                                validate={validate(Yup.date().typeError('Bitte gültiges Datum eingeben.')
                                    .min(getMinDate(),
                                    'Datum darf nicht länger als 42 Tage in der Vergangenheit liegen.')
                                    .max(new Date(), 'Datum darf nicht in der Zukunft liegen.')
                                    .required("Bitte das Ablesedatum angeben."))}
                                required/></>
    );

}